<template>
  <div class="account-page"
       :class="isHasSlide ? '_has-slide' : null"
  >
    <Breadcrumbs
      :links="breadCrumbsLinks"
      :backRoute="backRoute"/>
    <div class="account-page__main-wrap  container">
      <div class="account-page__main  container-inner">
        <AccountMenu v-if="!isResumePage && isLogged && user"
                     :user-type="user.user_type"
                     class="account-page__menu d-sm-none"/>
        <router-view class="account-page__content"/>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../assets/less/style-account.less'
  import Breadcrumbs from '../../components/Breadcrumbs'
  import AccountMenu from '../../components/AccountMenu'

  export default {
    name: 'Account',
    components: {
      Breadcrumbs,
      AccountMenu
    },
    data() {
      return {
        fromPath: null
      };
    },
    computed: {
      backRoute() {
        return this.fromPath ? {path: this.fromPath} : null
      },
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      user() {
        return this.$store.state.user.profile
      },
      isResumePage() {
        return this.isRouteNameMixin('received-resume')
      },
      breadCrumbsLinks() {
        const links = [{
          name: this.$tHeader('My account')
        }]

        return links
      },
      isHasSlide() {
        return this.isRouteNameMixin('account-new-vacancy')
          || this.isRouteNameMixin('account-new-resume')
          || this.isRouteNameMixin('account-interaction')
      }
    },
    methods: {
      refreshUserInfo() {
        this.$store.dispatch('user/loadUser')
      },
      setFromPath(from) {
        this.fromPath = from.name ? from.fullPath : null
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.refreshUserInfo()
        vm.setFromPath(from)
      })
    },
    beforeRouteUpdate(to, from, next) {
      if (to.name !== from.name) {
        this.refreshUserInfo()
        this.setFromPath(from)
      }
      next()
    }
  }
</script>

<style lang="less">

</style>
